export default __webpack_public_path__ + "static/media/Belt of the Huntmaster.565b162d.jpg";